import { CheckOutlined, DownOutlined, GlobalOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './locale-switch.module.scss';
import { useLocale } from './use-locale';
import { AppLocale, SUPPORTED_LOCALES } from './index';

const LOCALE_META: Record<AppLocale, { code: string }> = {
  'zh-CN': { code: 'zh-CN' },
  'en-US': { code: 'en-US' },
};

const ENABLE_LOCALE_SWITCH = false;

type LocaleSwitchProps = { size?: 'small' | 'middle' | 'large', className?: string | undefined };

// PoC 阶段的语言切换入口，正式 UI 后续接入到全局 header
const LocaleSwitchContent: FC<LocaleSwitchProps> = ({ size = 'small', className }) => {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocale();

  const getLocaleLabel = (target: AppLocale) => (target === 'zh-CN' ? t('中文') : 'English');

  const menu = useMemo(() => (
    <Menu
      selectedKeys={[locale]}
      onClick={({ key }) => setLocale(key as AppLocale)}
    >
      {SUPPORTED_LOCALES.map(item => (
        <Menu.Item key={item}>
          <span className={styles.option}>
            <span className={styles.optionText}>
              <span className={styles.optionMain}>{getLocaleLabel(item)}</span>
              <span className={styles.optionSub}>{LOCALE_META[item].code}</span>
            </span>
            {locale === item && <CheckOutlined className={styles.checkIcon} />}
          </span>
        </Menu.Item>
      ))}
    </Menu>
  ), [locale, setLocale, t]);

  return (
    <Dropdown
      overlay={menu}
      placement="bottomRight"
      trigger={['click']}
      overlayClassName={styles.dropdown}
    >
      <button
        type="button"
        className={`${styles.localeSwitch} ${styles[size]} ${className}`}
        aria-label={t('切换语言')}
      >
        <GlobalOutlined className={styles.globeIcon} />
        <span className={styles.currentLocale}>{getLocaleLabel(locale)}</span>
        <DownOutlined className={styles.arrowIcon} />
      </button>
    </Dropdown>
  );
};

export const LocaleSwitch: FC<LocaleSwitchProps> = props => (
  ENABLE_LOCALE_SWITCH ? <LocaleSwitchContent {...props} /> : null
);
